/*
 * Display copy for the CANDIDATE stage vocabulary — the collapsed set `candidateStage()` in
 * @velaigal/shared/stages produces, and the tokens `candidate_application_view` stores for the
 * seeker's own list: received | in_review | interviewing | hired | closed | withdrawn.
 *
 * Copy, not policy. stages.ts is explicit that the collapse is a pure function rather than a
 * generated column precisely so "display copy lives in the client" — so this map is the intended
 * home for the wording, and it is deliberately NOT a second copy of which stage collapses to
 * which. Two screens read it:
 *
 *   - src/pages/JobSeeker/Applications.tsx, the candidate's own list, whose rows carry these
 *     tokens straight from the view.
 *   - src/pages/HR/ApplicantDetail.tsx, which renders `candidateStage` off the POST /decisions
 *     response to tell the recruiter what the candidate's screen now says. That is the whole
 *     point of surfacing it: a recruiter who has just pressed Shortlist should be able to see
 *     that the candidate is NOT shown "shortlisted".
 *
 * Sharing the map is what keeps those two answers identical. A recruiter told the candidate sees
 * "In review" while the candidate's own page says something else would be worse than saying
 * nothing.
 *
 * A plain .ts module rather than a const in a .tsx page: vitest.web collects only
 * src/ ** /*.test.ts in a node environment with no JSX transform (vitest.web.config.ts), so copy
 * living in a .tsx file cannot be asserted on at all.
 */
export const CANDIDATE_STAGE_LABEL: Record<string, string> = {
  received: 'Received',
  in_review: 'In review',
  interviewing: 'Interviewing',
  hired: 'Hired',
  closed: 'Closed',
  withdrawn: 'Withdrawn',
};

export function candidateStageLabel(stage: string): string {
  return CANDIDATE_STAGE_LABEL[stage] ?? stage;
}
